{
  "title": "Commune with City (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "5th-level divination (ritual) (technomagic)",
  "level": 5,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You briefly become one with the city and gain knowledge of the surrounding area. Aboveground, this spell gives you knowledge of the area within 1 mile of you. In sewers and other underground settings, you gain knowledge of the area within 600 feet of you.",
    "You instantly gain knowledge of up to three facts of your choice about any of the following subjects as they relate to the area:",
    "Terrain and bodies of water",
    "Prevalent buildings, plants, animals, or intelligent creatures",
    "Powerful (CR 1 or higher) celestials, fey, fiends, elementals, or undead",
    "Influences from other planes of existence",
    "Electrical currents, wireless signals, and active transit lines and tracks",
    "For example, you could determine the location of powerful undead in the area, the location of major sources of electrical power or interference, and the location of any nearby parks."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
